// extracted by mini-css-extract-plugin
export default {"head":"TableProductHead_head__TmdkO","headColumn":"TableProductHead_headColumn__JaccT","sortButtonContainer":"TableProductHead_sortButtonContainer__58sXA"};